import CONSTANT from '../../constants'
import fetchWithAuthorizationHeader from '../../helper/fetchWithAuthorizationHeader'
import type { ProjectRequest } from '../../types/projects'

const { PROJECTS_API_URL } = CONSTANT

const createNewProject = async (newProject: ProjectRequest): Promise<any> => {
	const response = await fetchWithAuthorizationHeader(`${PROJECTS_API_URL}`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			action: 'CREATE'
		},
		body: JSON.stringify(newProject)
	})

	return response.json()
}

export default createNewProject
